import React from 'react';
import PropTypes from 'prop-types';
import { NavLink } from 'react-router-dom';
import { checkAllFeatureAccess } from '../../../utils/helpers';

const PrivateNavLinkNew = ({
  checkFeatureAccess,
  featureAccess,
  userAssignedFeatureAccesses,
  children,
  replacementComponent,
  dispatch,
  ...rest
}) => {
  if (rest.label === 'Admin' || rest.label === 'External Provider') {
    if (checkAllFeatureAccess(featureAccess, userAssignedFeatureAccesses)) {
      return <NavLink {...rest}>{children}</NavLink>;
    }
    return replacementComponent || null;
  }
  if (checkFeatureAccess(featureAccess)) {
    return <NavLink {...rest}>{children}</NavLink>;
  }
  return replacementComponent || null;
};

PrivateNavLinkNew.defaultProps = {
  replacementComponent: null,
  children: null,
};

PrivateNavLinkNew.propTypes = {
  // Required feature access
  featureAccess: PropTypes.arrayOf(PropTypes.string).isRequired,
  // Optional component/text to replace the link with if the user lacks the feature access
  replacementComponent: PropTypes.node,
  checkFeatureAccess: PropTypes.func.isRequired,
  children: PropTypes.node,
  dispatch: PropTypes.func.isRequired,
};

export default PrivateNavLinkNew;
